import { IListObjectStore } from '../../_common/type';
import { IJobHOCState } from '../../_core/job/types';
import { EMARPOLDocuments, TMARPOLProcessedTank } from '../marpol/@types';
import MARPOLModule from '../marpol/operation.types';
import { TBFL1A1 } from './groups/group-a';
import { TBFL1B1 } from './groups/group-b';
import { TBFL1C1 } from './groups/group-c';
import { TBFL1D1, TBFL1D2 } from './groups/group-d';

export enum EBFL1OperationState {
    RECORD = 'RECORD',
    PREVIEW = 'PREVIEW',
}

export enum EBFL1RecordState {
    APPROVED = 'APPROVED',
    STRIKED_OFF = 'STRIKED-OFF',
    SUBMITTED = 'SUBMITTED',
    IDLE = 'IDLE',
    EDIT = 'EDIT',
    VERIFIED = 'VERIFIED',
}

export type TBFL1RecordUser = {
    name: string;
    designation: string;
    staffId: string;
    date: string;
};

export type TBFL1CommonFields = {
    selectedDate: string;
    remarks: string;
};

export type TBFL1CommonData = {
    id: string;
    _rev: string;
    marpolType: EMARPOLDocuments.BFL1;
    state: EBFL1RecordState;
    submittedBy?: TBFL1RecordUser;
    approvedBy?: TBFL1RecordUser;
    verifiedBy?: TBFL1RecordUser;
    strikedBy?: TBFL1RecordUser;
    strikeOffReason?: string;
    processedTanks: TBFL1ProcessedTank[];
    editVersions?: TBFL1BackendRecord[];
    dateOfApprovedRecordEdit?: string;
    _attachments?: object;
};

export type TBFL1ObservedQuantity = {
    preOperation: number;
    postOperation: number;
    isHavingAutomaticCollection?: boolean;
    isValidationDisabled?: boolean;
};

export enum EBFL1RecordCode {
    BFL1A1 = 'BFL1-A1',
    BFL1B1 = 'BFL1-B1',
    BFL1C1 = 'BFL1-C1',
    BFL1D1 = 'BFL1-D1',
	BFL1D2 = 'BFL1-D2',
}

export type TBFL1Record = TBFL1A1 | TBFL1B1 | TBFL1C1 | TBFL1D1 | TBFL1D2;

export type TBFL1BackendRecord = TBFL1Record & {
    submittedBy: TBFL1RecordUser;
    approvedBy?: TBFL1RecordUser;
    verifiedBy?: TBFL1RecordUser;
    strikedBy?: TBFL1RecordUser;
    editedBy?: TBFL1RecordUser;
    nonParticipantTanks: { id: string; expectedQuantity: number }[];
    isAutoCreated?: boolean;
    isEditWarningVisible?: boolean;
};

export enum EBFL1EditMode {
    GENERAL = 'GENERAL',
    APPROVED_EDIT = 'APPROVED_EDIT',
}

export type TBFL1ProcessedTank = TMARPOLProcessedTank;
export type TBFL1CurrentOperation = {
    recordCode: EBFL1RecordCode;
    operationState: EBFL1OperationState;
    formData: TBFL1Record;
    validationAlerts: IListObjectStore<MARPOLModule.AlertInOperation>;
    processedTanks: IListObjectStore<TBFL1ProcessedTank>;
    editMode?: EBFL1EditMode;
};

export type TBFL1HistoryFilters = {
    startDate: any;
    endDate: any;
    shownRecords: 'ALL' | 'ALL-PENDING';
    state?: EBFL1RecordState | string;
    sortOrder?: 'asc' | 'desc';
	vesselId?: string;
};

export type TBFL1WeekReport = {
    totalRecords: number;
    pendingApprovalsCount: number;
    pendingVerificationsCount: number;
    strikedOffCount: number;
    lastSubmittedRecordCode?: EBFL1RecordCode;
    lastSubmittedRecordDate?: string;
    isLastRecordStrikedOff: boolean;
    isItSundayFirstHalf: boolean;
    isItSundaySecondHalf: boolean;
    isWeekEndDatePassed: boolean;
};

export interface IBFL1Store extends IJobHOCState {
    records: IListObjectStore<TBFL1BackendRecord>;
    currentOperation?: TBFL1CurrentOperation;
    filter: TBFL1HistoryFilters;
}
